/* Copyright (c) 2017 Backpack Health LLC */

import { apiRequest, authorizedApiRequest } from './ApiRequest';
import ApiErrorModel from '../models/ApiErrorModel';
import UserModel from '../models/UserModel';
import AppUtils from '../utilities/AppUtils';

const PasswordApi = {
  forgot: function forgotPassword() {
    return apiRequest('post', 'forgotPassword');
  },
  update: function updateForgotPassword(token) {
    return apiRequest('put', 'forgotPassword').set('Authorization', `Bearer ${token}`);
  },
  reset: function resetPassword(id) {
    return authorizedApiRequest('put', `users/${id}/password`);
  },
};

const PasswordService = {
  forgot(email, callback) {
    return PasswordApi.forgot()
    .send({
      email,
      subdomain: AppUtils.getSubdomain(),
    })
    .end((err) => {
      const apiError = err ? new ApiErrorModel(err) : null;
      callback(apiError, null);
    });
  },

  update(token, password, callback) {
    return PasswordApi.update(token)
    .send({
      password,
    })
    .end((err, res) => {
      const apiError = err ? new ApiErrorModel(err) : null;
      callback(apiError, new UserModel(res.body.data));
    });
  },

  reset(userId, callback) {
    return PasswordApi.reset(userId)
    .end((err) => {
      const apiError = err ? new ApiErrorModel(err) : null;
      callback(apiError, null);
    });
  },

};

export default PasswordService;
